import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { marginY } from "./constants";

export default makeStyles<Theme>((theme) => ({
  summaryWrapperRoot: {
    maxHeight: `calc(100vh - ${theme.spacing(marginY * 2)})`,
  },
}));
